import { makeStyles } from '@mui/material/styles';
import { spacing } from './Common';

export const paper = () => {
    return makeStyles(theme => {
        return getPaperStyleObject(theme);
    })();
};

export const getPaperStyleObject = (theme) => {
    return {
        root: {
            maxWidth: '304px',
            marginTop: spacing[3],
            marginBottom: spacing[3],
            paddingTop: spacing[7],
            paddingBottom: spacing[7],
            paddingLeft: spacing[1],
            paddingRight: spacing[1],
            [theme.breakpoints.up('sm')]: {
                padding: spacing[8],
                marginTop: spacing[3],
                marginBottom: spacing[3],
                width: '100%',
                maxWidth: '100%'
            }
        }
    };
};